// extracted by mini-css-extract-plugin
export default {"label":"nJigkufx","activityList":"pBZHpZqh","fee":"dGfWPiwI"};